export default "__VITE_ASSET__d8110ea4__"